"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderStrip = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.HeaderStrip = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-image: url(", ");\n  background-repeat: repeat-x;\n  height: 9px;\n  width: 100%;\n"], ["\n  background-image: url(", ");\n  background-repeat: repeat-x;\n  height: 9px;\n  width: 100%;\n"])), function (props) { return props.path; });
exports.default = exports.HeaderStrip;
var templateObject_1;
